import React, { Component } from 'react';
import PanelLink from "../../widgets/PanelLink";
import queryString from "query-string";

const OverduePanelLink = function (props) {

    let accounts = props.store.accounts.collection;

    let overdueNumber = accounts.reduce((acc, account) => {
        let payPeriods = account.getPayPeriods()

        if (payPeriods["unsubmitted"].length > 3) {
            return acc + 1;
        }
        return acc;
    }, 0);

    let redirectParams = queryString.stringify({overdueFilter: "Overdue"})


    return ( 
        <PanelLink path={`/staff/allAccountsSummary?${redirectParams}`}>
            <div>
                <span className="panelLinkLarge">{overdueNumber}</span>
            </div>
            <span>
                Overdue
            </span>
            <span>
                Accounts
            </span>
        </PanelLink>
    )
    
}

export default OverduePanelLink;